export enum EFileUploadErrorMessages {
  InvalidResponse = 'Unable to upload file',
  ErrorRequest = 'Unable to send upload file request',
}
